/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    func, string, bool, number,
} from 'prop-types';

// Material UI
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';

import TextFieldWrapper from '../Partials/TextFieldWrapper/TextFieldWrapper';
import ValidationRules from '../Partials/TextFieldWrapper/ValidationRules';

const style = {
    error: {
        color: '#f44336',
    },
    author: {
        display: 'block',
        marginTop: '20px',
    },
    yourMessage: {
        display: 'block',
        marginTop: '6px',
    },
    displayNone: {
        display: 'none',
    },
};

class GiftMessageMultiTextBox extends Component {
    constructor(props) {
        super(props);
        // State Maintained for Multi Line Textbox
        this.state = {
            form: {},
            alert: false,
            errorMessage: '',
        };
        this.GiftMessage = '';
        this.autoFill = false;
    }

    componentDidMount() {
        const { noOfLines } = this.props;
        const { form } = this.state;
        for (let i = 0; i < noOfLines; i += 1) {
            form[`giftMessageLine${i}`] = '';
        }

        this.initGiftMessage();
    }

    componentDidUpdate(prevProps) {
        const {
            value, noOfLines, savedGiftMessage, charPerLine,
        } = this.props;
        if (prevProps.savedGiftMessage !== savedGiftMessage) this.initGiftMessage();
        if (value && !this.autoFill) {
            this.autoFill = true;

            const propsGiftValue = value;
            const arrGiftMsg = propsGiftValue.split('|');
            const updateState = { ...this.state };
            let originalMessage = '';

            // split a single line into multiple lines based on charPerLine.
            const splitLine = (line) => this.splitTextIntoLines(line, charPerLine);

            for (let i = 0; i < noOfLines; i += 1) {
                // Split the line into lines respecting charPerLine.
                const lines = splitLine(arrGiftMsg[i]?.trim() || '');

                if (lines?.length > 1) {
                    for (let j = 0; j < lines?.length; j += 1) {
                        updateState.form[`giftMessageLine${i}`] = lines[j];
                        if (lines[j]) originalMessage += lines[j];
                        if (i < (noOfLines - 2)) {
                            i += 1;
                        }
                    }
                } else {
                    updateState.form[`giftMessageLine${i}`] = lines[0];
                    if (lines[0]) originalMessage += lines[0];
                }
            }

            this.setState(updateState);

            // concating gift message per line wise
            this.GiftMessage = originalMessage;

            if (this.GiftMessage.length > 0) {
                this.handleOnBlurMultiLine();
            }
            const giftMessage = { target: '' };
            giftMessage.target = { value: propsGiftValue };
            this.updateGiftMessage(giftMessage);
        }
    }

    splitTextIntoLines = (text, charPerLine) => {
        const words = text.match(/\S+/g); // Match non-space characters as words

        if (!words) {
            // If there are no words, return an empty array
            return [];
        }

        const lines = words.reduce((accumulator, word) => {
            const currentLine = accumulator.length > 0 ? accumulator[accumulator.length - 1] : '';

            if (currentLine.length + word.length + 1 <= charPerLine) {
                // Add the word to the current line if it doesn't exceed the character limit.
                accumulator[accumulator.length - 1] = currentLine + (currentLine.length > 0 ? ' ' : '') + word;
            } else {
                // Start a new line if adding the word would exceed the character limit.
                accumulator.push(word);
            }

            return accumulator;
        }, ['']);

        if (lines.length > 1 && lines[0] === '') {
            lines.shift(); // Remove the empty string if there's more than one line
        }

        return lines;
    }

    initGiftMessage = () => {
        const { savedGiftMessage, getAuthor } = this.props;
        let initGiftMessage = '';

        if (savedGiftMessage?.length > 0 && savedGiftMessage !== 'No Card Message') {
            initGiftMessage = savedGiftMessage;
            if (getAuthor) {
                const testMatch = savedGiftMessage.match(/From:/);
                if (testMatch?.length > 0) {
                    initGiftMessage = savedGiftMessage.replace(/From:/, '');
                }
            }
        }
        this.GiftMessage = initGiftMessage;
        const giftMessage = { target: { value: initGiftMessage } };
        this.updateGiftMessage(giftMessage);
    }

    getMultipleTextBox = () => {
        const {
            charPerLine, noOfLines, getAuthor, getYourMessage, signatureMaxChars,
        } = this.props;
        const { form } = this.state;
        const eachTextBoxLen = charPerLine;
        const listOFTextBoxes = [];

        for (let i = 0; i < noOfLines; i += 1) {
            listOFTextBoxes.push(
                <Grid key={`gridGM_${i}`}>
                    {(getYourMessage && (i === 0)) && <span htmlFor="author-name" style={style.yourMessage}><strong>Your Message</strong></span>}
                    {(getAuthor && (i === (noOfLines - 1))) && <span htmlFor="author-from" style={style.author}><strong>From</strong></span>}
                    <InputLabel style={style.displayNone} htmlFor={`giftMessageLine${i}`}>{`Your Message-${i}`}</InputLabel>
                    <TextFieldWrapper
                        setTextInputState={this.handleOnChangeMultiLine}
                        val={form[`giftMessageLine${i}`]}
                        id={`giftMessageLine${i}`}
                        name={`giftMessageLine${i}`}
                        inputType="AlphaNumericGiftMessage"
                        isInputFilled={this.handleOnBlurMultiLine}
                        max={i === (noOfLines - 1) ? signatureMaxChars : eachTextBoxLen}
                        variant="standard"
                        data-test={`checkout-gift-message-form-line-${i}`}      // do NOT change or remove data-test attribute
                        /**
                         * Autocapitalize prop hint at how the browser should present the
                         * virtual keyboard for a user to optimize text entry for the user.
                         * https://developers.google.com/web/updates/2015/04/autocapitalize
                         * Turn it off for all but first input box, preventing capitals.
                         */
                        inputProps={{
                            autoCapitalize: i === 0 ? 'sentences' : 'off',
                        }}
                    />
                </Grid>,
            );
        }

        const { alert, errorMessage } = this.state;
        return (
            <Grid>
                {listOFTextBoxes}
                {alert && (
                    <Typography style={style.error}>
                        {errorMessage}
                    </Typography>
                )}
            </Grid>
        );
    }

    handleOnBlurMultiLine = () => {
        const { isInputFilled } = this.props;
        const validate = ValidationRules.Mandatory({
            required: true,
            label: 'Gift Message',
            value: this.GiftMessage,
        });
        const alert = validate.flagError;
        this.setState({
            alert,
            errorMessage: validate.errorMessage,
        }, () => {
            isInputFilled('giftMessage', alert, validate.payload);
        });
    }

    handleOnChangeMultiLine = (event) => {
        const { target: { name } } = event;
        const updateState = { ...this.state };
        updateState.form[name] = event.target.value;
        let messageLine = event.target.value;
        let lastWord = '';
        let focusNextLine = false;
        // eslint-disable-next-line radix
        const positionGM = parseInt(name.replace('giftMessageLine', '')) + 1;
        const { noOfLines, charPerLine } = this.props;
        const { form } = this.state;

        if (typeof document !== 'undefined'
            && positionGM < noOfLines && charPerLine
            && event.target.value.length >= charPerLine
            && document.getElementById(`giftMessageLine${positionGM}`)
            && document.getElementById(`giftMessageLine${positionGM}`).value.length === 0
        ) {
            focusNextLine = true;
            // Get the last word for set in the next line.
            if (event.target.value.length === charPerLine) {
                lastWord = messageLine.slice(messageLine.lastIndexOf(' ') + 1);
                messageLine = messageLine.substring(0, messageLine.lastIndexOf(' ') + 1); // Get the message line without last word
                if (messageLine === '') { // handle words that match charPerLine
                    messageLine = `${lastWord}`;
                    lastWord = '';
                } else {
                    const noOfLinesFound = lastWord.length;
                    const emptySpace = new Array(noOfLinesFound + 1).join(' ');
                    messageLine = `${messageLine}${emptySpace}`;
                }
            }
        }

        this.setState(updateState, () => {
            const { form: formState } = this.state;
            const giftMessageArray = Object.keys(formState).map((msg) => formState[msg]);
            const giftMessage = { target: '' };
            giftMessage.target = { value: giftMessageArray.join('|') };
            this.GiftMessage = giftMessageArray.join('');
            this.updateGiftMessage(giftMessage);
            this.handleOnBlurMultiLine();
        });

        if (focusNextLine) {
            form[`giftMessageLine${positionGM - 1}`] = messageLine;
            form[`giftMessageLine${positionGM}`] = lastWord;
            document.getElementById(`giftMessageLine${positionGM}`).focus();
        }
    }

    updateGiftMessage = (giftMessage) => {
        const {
            maxNoOfChar,
            handleChangeGiftMessageText,
        } = this.props;

        const messageLen = maxNoOfChar - this.GiftMessage.length;

        handleChangeGiftMessageText({
            value: giftMessage.target.value,
            messageLen,
        });
    }

    render() {
        return (
            <Grid>
                {this.getMultipleTextBox()}
            </Grid>
        );
    }
}

GiftMessageMultiTextBox.propTypes = {
    savedGiftMessage: string.isRequired,
    noOfLines: number.isRequired,
    handleChangeGiftMessageText: func.isRequired,
    isInputFilled: func.isRequired,
    maxNoOfChar: number.isRequired,
    charPerLine: number.isRequired,
    signatureMaxChars: number.isRequired,
    value: string.isRequired,
    getAuthor: bool,
    getYourMessage: bool,
};

GiftMessageMultiTextBox.defaultProps = {
    getAuthor: false,
    getYourMessage: false,
};

export default GiftMessageMultiTextBox;
